import CloseIcon from '@mui/icons-material/Close'
import AttachMoneyIcon from '@mui/icons-material/AttachMoney'
import {
  Box,
  Button,
  Chip,
  Grid,
  Stack,
  Tooltip,
  Typography,
} from '@mui/material'
import { ProductPriceDetailOrderBumpsProps } from './ProductPriceTypes'
import { useContext } from 'react'
import { AuthContext } from '../../../../../core/context/AuthContext'
import { EmptyOrderBumps } from '../../../../../components/Product/OrderBumps/EmptyOrderBumps'

const ProductPriceDetailOrderBumps = ({
  price,
  setPrice,
  onOrderBump,
}: ProductPriceDetailOrderBumpsProps) => {
  const { isUserSysAdmin } = useContext(AuthContext)

  const hasOrderBumps = !!price.orderBumps?.length

  return (
    <>
      <Stack
        direction="row"
        spacing={1}
        alignItems="center"
        justifyContent="space-between"
        sx={{ mb: 2 }}
      >
        <Typography
          color="#343948"
          fontSize="16px"
          lineHeight="20px"
          fontWeight={700}
        >
          Order Bumps{' '}
          {(price?.orderBumps?.length || 0) > 0
            ? `(${price?.orderBumps?.length || 0})`
            : ''}
        </Typography>

        {!isUserSysAdmin() && (
          <Button
            variant="outlined"
            size="large"
            sx={{ textTransform: 'none' }}
            onClick={onOrderBump}
          >
            <Typography fontWeight={700} fontSize="14px" lineHeight="24px">
              + Adicionar Order Bump
            </Typography>
          </Button>
        )}
      </Stack>

      <EmptyOrderBumps
        visible={!hasOrderBumps}
        disabled={isUserSysAdmin()}
        onAddClick={onOrderBump}
      />

      {hasOrderBumps && (
        <Stack direction="row" spacing={1} useFlexGap flexWrap="wrap">
          {price.orderBumps
            ?.sort((a, b) => (a.order || 0) - (b.order || 0))
            .map((orderBump, orderBumpIndex) => {
              const name = orderBump.productPrice?.product?.name || ''
              const value = (orderBump.productPrice?.value || 0).toFixed(2)

              return (
                <Grid item key={`productOrderBump${orderBumpIndex}`}>
                  <Tooltip title={name} arrow disableInteractive>
                    <Chip
                      disabled={isUserSysAdmin()}
                      variant="outlined"
                      icon={<AttachMoneyIcon fontSize="small" />}
                      deleteIcon={<CloseIcon />}
                      onDelete={() => {
                        price.orderBumps = price.orderBumps?.filter(
                          (ob) => ob.orderBumpId !== orderBump.orderBumpId
                        )
                        setPrice({ ...price })
                      }}
                      label={
                        <Stack
                          direction="row"
                          spacing={1}
                          alignItems="center"
                          sx={{ py: 0.25 }}
                        >
                          {/* Ordem */}
                          <Box
                            sx={{
                              minWidth: 26,
                              height: 22,
                              px: 0.75,
                              borderRadius: 1.2,
                              display: 'inline-flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              bgcolor: 'rgba(28, 82, 189, 0.12)',
                              color: 'rgba(28, 82, 189, 1)',
                              fontWeight: 700,
                              fontSize: 12,
                            }}
                          >
                            #{orderBump.order || 0}
                          </Box>

                          {/* Nome */}
                          <Typography
                            sx={{
                              maxWidth: 220,
                              overflow: 'hidden',
                              textOverflow: 'ellipsis',
                              whiteSpace: 'nowrap',
                              fontFamily: 'Montserrat',
                              fontWeight: 600,
                              fontSize: 12,
                              color: 'rgba(28, 82, 189, 1)',
                            }}
                          >
                            {name}
                          </Typography>

                          {/* Preço */}
                          <Typography
                            sx={{
                              fontFamily: 'Montserrat',
                              fontWeight: 700,
                              fontSize: 12,
                              color: 'rgba(28, 82, 189, 1)',
                              opacity: 0.9,
                            }}
                          >
                            R$ {value}
                          </Typography>
                        </Stack>
                      }
                      sx={{
                        height: 36,
                        borderRadius: 2,
                        borderColor: 'rgba(216, 217, 255, 1)',
                        bgcolor: 'rgba(216, 217, 255, 0.55)',
                        color: 'rgba(28, 82, 189, 1)',
                        '& .MuiChip-icon': { color: 'rgba(28, 82, 189, 1)' },
                        '& .MuiChip-deleteIcon': {
                          color: 'rgba(28, 82, 189, 0.65)',
                          '&:hover': { color: 'rgba(28, 82, 189, 1)' },
                        },
                      }}
                    />
                  </Tooltip>
                </Grid>
              )
            })}
        </Stack>
      )}
    </>
  )
}

export default ProductPriceDetailOrderBumps
